import { useMutation, useQueryClient } from "react-query";
import { approvedInvoice } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";
import { toast } from "../../../../../components/toastNotification";

export const useApprovedInvoiceDetails = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (ids: number[] | undefined) => approvedInvoice(ids),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["GetForReviewInvoices"]);

        toast.fire(
          "Success",
          "Vendor Invoice has been Approved successfully",
          "success"
        );
      },

      onError: () => {
        toast.fire(
          "Bulk Approved of Vendor Invoice failed",

          "Server Error: Cannot Approved Vendor Invoice",

          "error"
        );
      },
    }
  );

  return mutate;
};
